import axios from "axios";
import { load } from "@cashfreepayments/cashfree-js";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Start a Cashfree hosted checkout for an existing HerbKranti order.
 * Backend creates the Cashfree order (credentials stay server-side) and returns a
 * payment_session_id; the Cashfree JS SDK then redirects to the hosted payment page.
 * The customer comes back to /order/:id?cf_return=1 where the status is verified server-side.
 */
export async function startCashfreeCheckout(order) {
  const returnUrl = `${window.location.origin}/order/${order.id}`;
  const { data } = await axios.post(`${API}/orders/${order.id}/cashfree/create`, { return_url: returnUrl });
  const cashfree = await load({ mode: data.environment === "production" ? "production" : "sandbox" });
  if (!cashfree) throw new Error("Cashfree SDK failed to load. Please refresh and try again.");
  const result = await cashfree.checkout({ paymentSessionId: data.payment_session_id, redirectTarget: "_self" });
  if (result?.error) throw new Error(result.error.message || "Could not open Cashfree checkout.");
  return data;
}

/** Ask the backend to reconcile the Cashfree payment (server-to-server truth). */
export async function verifyCashfreePayment(orderId) {
  const { data } = await axios.post(`${API}/orders/cashfree/verify`, { order_id: orderId });
  return data; // { ok, payment_status: 'paid' | 'pending' | 'failed' | 'cancelled' }
}
